module.exports = __webpack_public_path__ + "media/images/athletes/506-4e37db1ca98285ca11d2a4d99714ddf1.png";